import script from "./basicInfoChange.vue?vue&type=script&setup=true&lang=js"
export * from "./basicInfoChange.vue?vue&type=script&setup=true&lang=js"

import "./basicInfoChange.vue?vue&type=style&index=0&id=72f02206&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72f02206"]])

export default __exports__